import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.main`
  /* max-width: 1120px; */
  margin-right: 50px;
  display: flex;
`;

export const ContentArea = styled.main`
  /* position: absolute; */
  height: 100vh;

  margin-left: 250px;

  h2 {
    margin-top: 40px;
  }
  h3 {
    margin-top: 20px;
  }
`;

export const FormContainerHeader = styled.div`
  margin-top: 30px;
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 1.6rem;
  row-gap: 1.6rem;

  strong {
    color: #09432f;
    font-size: 20px;
    font-weight: bold;
  }
`;

export const FormContainer = styled.div`
  margin-top: 60px;
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  column-gap: 1.6rem;
  row-gap: 1.6rem;

  a {
    text-decoration: none;
    color: #323a55;
    font-size: 20px;

    &:hover {
      font-weight: 700;
    }
  }

  label {
    cursor: pointer;
  }

  .birthDiv {
    margin-top: 20px;
  }
`;

export const Section = styled.section`
  margin-top: 10px;

  > strong {
    color: #999591;
    font-size: 20px;
    line-height: 26px;
    border-bottom: 1px solid #3e3b47;
    display: block;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  > p {
    color: #999591;
  }
`;

export const ProcessClient = styled.div`
  display: flex;
  align-items: center;

  border-bottom: 1px solid #2d344c;

  /* & + div {
    margin-top: 5px;
  } */

  span {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: #f4ede8;
    width: 70px;
  }

  .child_div {
    div {
      // border: 3px solid #73AD21;

      margin-left: auto;
      display: flex;
      align-items: right;
      color: #f4ede8;
      max-width: 140px;
    }
  }

  div {
    flex: 1;
    background: #e8e8e8;
    display: flex;
    align-items: center;
    padding: 16px 8px;
    /* border-radius: 10px; */
    /* margin-left: 8px; */

    strong {
      margin-left: 3px;
      color: #323a55;
      font-size: 15px;
    }

    svg {
      color: #ff9000;
      margin-left: 24px;
      cursor: pointer;
    }

    
  }
`;
